<template>
  <component
    :is="tag"
    class="card-standard"
    :class="cardClasses"
  >
    <slot />
  </component>
</template>

<script setup>
import { computed } from 'vue'
import { cx } from '@/helpers'

defineOptions({ name: 'Card' })
const props = defineProps({
  tag: { type: String, default: 'div' },
  flat: { type: Boolean, default: false },
  bordered: { type: Boolean, default: true },
  type: {
    type: String,
    default: 'float',
    validator: v => ['base', 'surf', 'float', 'overlay'].includes(v)
  }
})

const cardClasses = computed(() => cx(
  props.flat && 'is-flat',
  props.bordered && 'is-bordered',
  `type-${props.type}`
))
</script>

<style scoped>
@reference "#app-styles.css";

.card-standard {
  @apply relative rounded-lg align-top;

  &:not(.is-flat) { @apply shadow-md; }

  &.type-base { @apply layer-base; }
  &.type-surf { @apply layer-surf; }
  &.type-float { @apply layer-float; }
  &.type-overlay { @apply layer-overlay; }

  &.is-bordered {
    &.type-base { @apply surface-base; }
    &.type-surf { @apply surface-surf; }
    &.type-float { @apply surface-float; }
    &.type-overlay { @apply surface-overlay; }
  }

  &:deep(.card-standard--section) {
    @apply relative px-4 py-3;

    &.is-horizontal {}
  }

  &:deep(.card-standard--actions) {
    @apply flex items-center gap-1 px-4 py-3;

    &.align-left { @apply justify-start content-start; }
    &.align-center { @apply justify-center content-center; }
    &.align-right { @apply justify-end content-end; }
    &.align-between { @apply justify-between content-between; }
    &.align-around { @apply justify-around content-around; }
    &.align-evenly { @apply justify-evenly content-evenly; }
    &.align-stretch { @apply justify-stretch content-stretch; }

    &.is-vertical {
      @apply flex-col;

      &.align-left { @apply items-start; }
      &.align-center { @apply items-center; }
      &.align-right { @apply items-end; }
      &.align-between { @apply items-stretch; }
      &.align-around { @apply items-stretch; }
      &.align-evenly { @apply items-stretch; }
      &.align-stretch { @apply items-stretch; }
    }
  }

  & > img {
    display: block;
    width: 100%;
    max-width: 100%;
    border: 0;
  }
}
</style>
